<template>
  <ReportDashboardDefault />
</template>

<script setup lang="ts">
import ReportDashboardDefault from './ReportDashboardDefault.vue';
</script>
